import {gql} from "@irati/utils/gql"

export default gql`
  fragment fullInternalUser on InternalUser {
    uuid
    email
    featureFlags
    fullName
    isEnabled
    locationDescription
    profileImageUrl
    shortDescription
  }
`
